// extracted by mini-css-extract-plugin
export default {"need_container_desc":"assessmentneed_need_container_desc__UZ11c","need_container_title":"assessmentneed_need_container_title__y3HH9"};